<template>
  <ReassuranceItem :has-background="!hasDeliveryBeforeChristmas">
    <template #icon>
      <RevIllustration
        v-if="hasDeliveryBeforeChristmas"
        alt=""
        class="h-24 w-24 md:h-32 md:w-32"
        :height="48"
        src="/img/product/delivery-before-christmas.svg"
        :width="48"
      />
      <IconTruckExpress v-else class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      <ShippingTitle :shipping />
    </template>
    <template #subtitle>
      <ShippingSubtitle :shipping />
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { RevIllustration } from '@ds/components/Illustration'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import { useDeliveryBeforeChristmas } from '~/scopes/product/composables/useDeliveryBeforeChristmas'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import ShippingSubtitle from './components/ShippingSubtitle/ShippingSubtitle.vue'
import ShippingTitle from './components/ShippingTitle/ShippingTitle.vue'

const props = defineProps<{
  shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
}>()

const { hasDeliveryBeforeChristmas } = useDeliveryBeforeChristmas(
  props.shipping,
)
</script>
